@if (showNotification() && message(); as message) {
  <wl-notification [message]="message" />
}
